import { render, staticRenderFns } from "./downBottomImg.vue?vue&type=template&id=bbbf8050&scoped=true"
import script from "./downBottomImg.vue?vue&type=script&lang=js"
export * from "./downBottomImg.vue?vue&type=script&lang=js"
import style0 from "./downBottomImg.vue?vue&type=style&index=0&id=bbbf8050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf8050",
  null
  
)

export default component.exports